import { Injectable } from "@angular/core"
import { Http } from "@angular/http"
import { Observable } from 'rxjs/Observable'
import { HttpHelperService } from './helpers/http-helper.service'
import { BehaviorSubject } from "rxjs"
import { UserService } from "./user.service";

@Injectable()
export class FavouriteService {

	private favouritesSource: BehaviorSubject<any> = new BehaviorSubject([])

	constructor(
		private http: Http,
		private httpHelperService: HttpHelperService
	) { }

	get Favourites() {
		return this.favouritesSource.asObservable()
	}

	getFavourites(data) {
		const body = data
		this.http.post('/api/favourites/getfavourites', body, { headers: this.httpHelperService.headers(true, UserService.token) })
			.subscribe((res: any) => {
				let result = res.json()
				this.favouritesSource.next(result)
			},
			error => {
				console.log(error)
			})
	}
}



// WEBPACK FOOTER //
// ./src/app/services/favourite.service.ts